import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import useAuth from "./useAuth";

// hook to logout the user
const useLogout = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const logout = () => {
    setAuth({ isAuthenticated: false });
    Cookies.remove("refreshToken");
    navigate("/login");
  };

  return logout;
};
export default useLogout;
